/**
 * @memberOf app
 * @ngdoc module
 * @description Authentication module used for authenticating -- after the user has clicked the magic link
 * @name app.authenticate
 */

import routing from './authenticate.route';
import AuthenticateController from './authenticate.controller';

export default angular.module('app.authenticate', [])
  .config(routing)
  .controller('AuthenticateController', AuthenticateController)
  .name;



// WEBPACK FOOTER //
// ./src/client/app/authenticate/authenticate.module.js